/* chill & slumber · theme script
   Bag drawer, quick add, product page, size guide, countdowns, videos and help search.
   No libraries needed. Loaded by snippets/cs-head.liquid. */
(function () {
  'use strict';
  var T = window.csTheme || {};
  var L = T.t || {};
  function tr(k, fallback) { return L[k] || fallback; }
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- money ---------- */
  function money(cents) {
    var fmt = T.moneyFormat || '€{{amount_with_comma_separator}}';
    cents = Number(cents) || 0;
    function group(n, dec, thou, sep) {
      var parts = (n / 100).toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.length > 1 ? parts[0] + sep + parts[1] : parts[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return group(cents, 2, ',', '.');
        case 'amount_no_decimals': return group(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return group(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(cents, 2, "'", '.');
        default: return group(cents, 2, '.', ',');
      }
    }).replace(/<[^>]*>/g, '');
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- toast (no browser alerts) ---------- */
  function toast(msg) {
    var t = $('.cs-toast');
    if (!t) { t = document.createElement('div'); t.className = 'cs-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 3500);
  }

  /* ---------- cart api ---------- */
  var root = (T.rootUrl || '/').replace(/\/$/, '');
  function api(path, body) {
    var opts = body ? { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) } : { headers: { 'Accept': 'application/json' } };
    return fetch(root + path, opts).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) { throw new Error(j.description || j.message || 'Something went wrong'); } return j; });
    });
  }
  function getCart() { return api('/cart.js'); }
  function addItems(items) {
    return api('/cart/add.js', { items: items }).then(function () { return topUpGift(items); }).then(function () { return refreshDrawer(true); }).catch(function (e) { toast(e.message); return null; });
  }
  /* Free gift (e.g. a mask with every pre-order): one matching gift per qualifying product.
     Added and removed automatically; the price is made €0 by a "Buy X get Y" automatic discount in Shopify. */
  function topUpGift(added) {
    var g = T.gift;
    if (!g || !g.variants || !g.variants.length) { return Promise.resolve(); }
    return getCart().then(function (cart) {
      var trig = 0, gifts = 0, giftLine = 0, opts = [];
      var lastId = added && added.length ? added[0].id : null;
      cart.items.forEach(function (it, i) {
        if ((g.triggerIds || [g.triggerId]).indexOf(it.product_id) > -1) {
          trig += it.quantity;
          if (!opts.length || it.variant_id === lastId) { opts = (it.options_with_values || []).map(function (o) { return o.value; }); }
        }
        if (it.product_id === g.giftId && it.properties && it.properties[g.label]) { gifts += it.quantity; giftLine = giftLine || i + 1; }
      });
      var need = trig - gifts;
      if (need < 0 && giftLine) {
        var line = cart.items[giftLine - 1];
        return api('/cart/change.js', { line: giftLine, quantity: Math.max(0, line.quantity + need) }).catch(function () {});
      }
      if (need <= 0) { return; }
      var gv = g.variants.filter(function (v) { return v.available && v.options.some(function (o) { return opts.indexOf(o) > -1; }); })[0] || g.variants.filter(function (v) { return v.available; })[0];
      if (!gv) { return; }
      var props = {}; props[g.label] = 'Yes';
      return api('/cart/add.js', { items: [{ id: gv.id, quantity: need, properties: props }] }).catch(function () {});
    });
  }
  function preProps(v) { return v && v.pre ? { 'Pre-order': T.preorderLabel || 'Pre-order' } : undefined; }
  function item(v, qty) { var it = { id: v.id, quantity: qty || 1 }; var p = preProps(v); if (p) { it.properties = p; } return it; }

  /* ---------- drawer ---------- */
  var drawer = $('[data-cs-drawer]');
  function openDrawer() {
    if (!drawer) { window.location.href = T.cartUrl || '/cart'; return; }
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cs-lock');
    var p = $('.cs-drawer__panel', drawer); if (p) { p.focus(); }
  }
  function closeDrawer() {
    if (!drawer) { return; }
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cs-lock');
  }
  function updateBubble(count) {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) { return; }
    var b = $('.cart-count-bubble', icon);
    if (count > 0) {
      if (!b) { b = document.createElement('div'); b.className = 'cart-count-bubble'; icon.appendChild(b); }
      b.innerHTML = '<span aria-hidden="true">' + count + '</span><span class="visually-hidden">' + count + ' items</span>';
    } else if (b) { b.remove(); }
  }
  function renderDrawer(cart) {
    if (!drawer) { return; }
    var lines = $('[data-cs-lines]', drawer), empty = $('[data-cs-empty]', drawer), foot = $('[data-cs-foot]', drawer);
    var ship = $('[data-cs-ship]', drawer), upsell = $('[data-cs-upsell]', drawer), preNote = $('[data-cs-preorder-note]', drawer);
    $('[data-cs-count]', drawer).textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    updateBubble(cart.item_count);
    var isEmpty = cart.item_count === 0;
    empty.hidden = !isEmpty; foot.hidden = isEmpty; ship.hidden = isEmpty;
    if (upsell) { upsell.hidden = isEmpty; }
    var hasPre = false, hasStock = false, html = '';
    cart.items.forEach(function (it, i) {
      var pre = it.properties && it.properties['Pre-order'];
      var isGift = T.gift && it.properties && it.properties[T.gift.label];
      if (pre) { hasPre = true; } else if (!isGift) { hasStock = true; }
      var img = it.featured_image && it.featured_image.url ? it.featured_image.url + (it.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
      var variant = it.product_has_only_default_variant ? '' : (it.variant_title || '').replace(/ \/ /g, ' · ');
      html += '<div class="cs-line" data-line="' + (i + 1) + '">' +
        '<a href="' + esc(it.url) + '" class="cs-line__img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="cs-line__info"><div class="cs-line__top"><a href="' + esc(it.url) + '" class="cs-line__name">' + esc(it.product_title) + '</a><span>' + money(it.final_line_price) + '</span></div>' +
        (variant ? '<span class="cs-line__var">' + esc(variant) + '</span>' : '') +
        (isGift ? '<span class="cs-pill cs-pill--inline">' + esc(T.gift.label) + '</span>' : pre ? '<span class="cs-pill cs-pill--inline">' + esc(pre) + '</span>' : '<span class="cs-line__stock">' + esc(T.inStockLine || 'In stock') + '</span>') +
        '<div class="cs-line__bottom"><span class="cs-qty"><button type="button" data-qty="' + (it.quantity - 1) + '" aria-label="' + esc(tr('decrease', 'Decrease')) + '">−</button><span>' + it.quantity + '</span><button type="button" data-qty="' + (it.quantity + 1) + '" aria-label="' + esc(tr('increase', 'Increase')) + '">+</button></span>' +
        '<button type="button" class="cs-link" data-qty="0">' + esc(tr('remove', 'Remove')) + '</button></div></div></div>';
    });
    lines.innerHTML = html;
    /* Only when the bag has both: in-stock items and a pre-order ship separately */
    if (preNote) { preNote.hidden = !(hasPre && hasStock && T.preorderNote); }
    if (upsell) {
      var pid = Number(upsell.getAttribute('data-product-id'));
      var inCart = cart.items.some(function (it) { return it.product_id === pid; });
      upsell.hidden = isEmpty || inCart;
    }
    var th = Number(T.freeShippingThreshold) || 0, total = cart.total_price;
    var text = $('[data-cs-ship-text]', drawer), bar = $('[data-cs-ship-bar]', drawer), small = $('[data-cs-ship-small]', drawer);
    if (th > 0) {
      var left = th - total;
      text.innerHTML = left > 0 ? tr('ship_away', 'You’re <b>[amount] away</b> from free EU shipping').replace('[amount]', money(left)) : '🎉 <b>' + tr('ship_unlocked', 'You’ve unlocked free EU shipping') + '</b>';
      bar.style.width = Math.min(100, Math.round(total / th * 100)) + '%';
      if (small) { small.innerHTML = left > 0 ? tr('shipping_at_checkout', 'Shipping calculated at checkout.') : tr('shipping_free', 'Shipping: <b>free</b>.'); }
    } else { ship.hidden = true; }
    $('[data-cs-subtotal]', drawer).textContent = money(total);
    $('[data-cs-total]', drawer).textContent = money(total);
  }
  function refreshDrawer(open) {
    return getCart().then(function (cart) { renderDrawer(cart); if (open) { openDrawer(); } return cart; });
  }
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-cs-drawer-close]')) { closeDrawer(); return; }
      var q = e.target.closest('[data-qty]');
      if (q) {
        var line = Number(q.closest('[data-line]').getAttribute('data-line'));
        q.disabled = true;
        api('/cart/change.js', { line: line, quantity: Math.max(0, Number(q.getAttribute('data-qty'))) }).then(function () { return topUpGift(null); }).then(function () { return refreshDrawer(false); }).catch(function (err) { toast(err.message); refreshDrawer(false); });
        return;
      }
      var a = e.target.closest('[data-cs-add]');
      if (a) { addItems([{ id: Number(a.getAttribute('data-cs-add')), quantity: 1, properties: a.getAttribute('data-cs-add-pre') ? { 'Pre-order': T.preorderLabel } : undefined }]); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); } });
    var onCartPage = window.location.pathname.replace(/\/$/, '') === (T.cartUrl || '/cart');
    document.addEventListener('click', function (e) {
      var link = e.target.closest('#cart-icon-bubble, a[href="' + (T.cartUrl || '/cart') + '"].header__icon');
      if (link && !onCartPage) { e.preventDefault(); refreshDrawer(true); }
    });
    refreshDrawer(false).catch(function () {});
  }

  /* ---------- quick add on cards ---------- */
  /* Pick a colour (from the swatches under the card or inside the quick add): remembers it for the size buttons,
     marks it active and shows that colour's photo when the variant has one. */
  function pickColour(card, qa, colour) {
    var variants = JSON.parse(($('[data-cs-variants]', qa) || {}).textContent || '[]');
    var ci = Number(qa.getAttribute('data-colour-index'));
    if (ci < 0) { return null; }
    var sel = variants.filter(function (x) { return String(x.id) === qa.getAttribute('data-selected'); })[0];
    var same = variants.filter(function (x) { return x.options[ci] === colour; });
    var v = same.filter(function (x) { return sel && x.available && x.options.every(function (o, i) { return i === ci || o === sel.options[i]; }); })[0] ||
      same.filter(function (x) { return x.available; })[0] || same[0];
    if (!v) { return null; }
    qa.setAttribute('data-selected', v.id);
    $$('[data-cs-qa-colour], [data-cs-swatch]', card).forEach(function (b) {
      var on = (b.getAttribute('data-cs-qa-colour') || b.getAttribute('data-cs-swatch')) === colour;
      b.classList.toggle('is-active', on);
    });
    var nameEl = $('[data-cs-qa-colour-name]', card); if (nameEl) { nameEl.textContent = colour; }
    var img = $('.cs-card__img:not(.cs-card__img--hover)', card);
    if (img && v.card) { img.removeAttribute('srcset'); img.src = v.card; }
    return v;
  }
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-cs-swatch]');
    if (sw) {
      var card = sw.closest('[data-cs-card]'), q = card && $('[data-cs-qa]', card);
      if (q) { pickColour(card, q, sw.getAttribute('data-cs-swatch')); }
      return;
    }
    var qa = e.target.closest('[data-cs-qa]');
    if (!qa) { return; }
    var variants = JSON.parse(($('[data-cs-variants]', qa) || {}).textContent || '[]');
    var colBtn = e.target.closest('[data-cs-qa-colour]');
    if (colBtn) {
      var cv = pickColour(qa.closest('[data-cs-card]') || qa, qa, colBtn.getAttribute('data-cs-qa-colour'));
      /* No sizes (e.g. the mask): choosing the colour adds it straight away */
      if (cv && Number(qa.getAttribute('data-size-index')) < 0) {
        if (!cv.available) { toast(tr('size_sold_out', 'That size is sold out right now.')); return; }
        colBtn.disabled = true;
        addItems([item(cv)]).finally(function () { colBtn.disabled = false; qa.classList.remove('is-open'); });
      }
      return;
    }
    var direct = e.target.closest('[data-cs-qa-add]');
    if (direct) {
      var v = variants.filter(function (x) { return String(x.id) === direct.getAttribute('data-cs-qa-add'); })[0] || { id: Number(direct.getAttribute('data-cs-qa-add')) };
      direct.disabled = true;
      addItems([item(v)]).finally(function () { direct.disabled = false; });
      return;
    }
    if (e.target.closest('[data-cs-qa-open]')) { qa.classList.toggle('is-open'); return; }
    var sizeBtn = e.target.closest('[data-cs-qa-size]');
    if (sizeBtn) {
      var idx = Number(qa.getAttribute('data-size-index'));
      var size = sizeBtn.getAttribute('data-cs-qa-size');
      var sel = variants.filter(function (x) { return String(x.id) === qa.getAttribute('data-selected'); })[0];
      var match = variants.filter(function (x) {
        if (x.options[idx] !== size) { return false; }
        if (!sel) { return true; }
        return x.options.every(function (o, i) { return i === idx || o === sel.options[i]; });
      })[0] || variants.filter(function (x) { return x.options[idx] === size && x.available; })[0];
      if (!match || !match.available) { toast(tr('size_sold_out', 'That size is sold out right now.')); return; }
      sizeBtn.disabled = true;
      addItems([item(match)]).finally(function () { sizeBtn.disabled = false; qa.classList.remove('is-open'); });
    }
  });

  /* ---------- product page ---------- */
  $$('[data-cs-pdp]').forEach(function (pdp) {
    var variants = JSON.parse($('[data-cs-variants]', pdp).textContent);
    var upsellEl = $('[data-cs-upsell-variants]', pdp);
    var upsellVariants = upsellEl ? JSON.parse(upsellEl.textContent) : [];
    var input = $('[data-cs-variant-input]', pdp);
    var form = $('[data-cs-pform]', pdp);
    var btn = $('[data-cs-add-btn]', pdp);
    var current = variants.filter(function (v) { return String(v.id) === input.value; })[0] || variants[0];
    var selected = current.options.slice();
    var fieldsets = $$('[data-cs-option]', pdp);

    function find(opts) { return variants.filter(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); })[0]; }
    function stockLine(v) {
      if (!v || !v.available) { return '<span class="cs-stock--out">' + esc(tr('sold_out', 'Sold out')) + '</span>'; }
      if (v.pre) { return '<span class="cs-pill cs-pill--inline">' + esc(T.preorderLabel) + '</span>'; }
      if (v.qty > 0 && v.qty <= (T.lowStockAt || 5)) { var rest = (T.inStockLine || '').split('·').slice(1).join('·').trim(); return '<span class="cs-dot"></span> ' + esc(tr('only_left', 'Only [count] left').replace('[count]', v.qty)) + (rest ? ' · ' + esc(rest) : ''); }
      return '<span class="cs-dot"></span> ' + esc(T.inStockLine || 'In stock');
    }
    function mark() {
      fieldsets.forEach(function (fs) {
        var oi = Number(fs.getAttribute('data-cs-option'));
        $$('[data-value]', fs).forEach(function (b) {
          var test = selected.slice(); test[oi] = b.getAttribute('data-value');
          var v = find(test);
          b.classList.toggle('is-out', !v || !v.available);
          var on = b.getAttribute('data-value') === selected[oi];
          b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        var lbl = $('[data-cs-option-value]', fs); if (lbl) { lbl.textContent = selected[oi]; }
      });
    }
    function update() {
      var v = find(selected);
      current = v;
      mark();
      var stock = $('[data-cs-stock]', pdp);
      if (stock) { stock.innerHTML = stockLine(v); }
      if (!v) { btn.disabled = true; btn.textContent = tr('unavailable', 'Unavailable'); return; }
      input.value = v.id;
      $('[data-cs-price]', pdp).textContent = money(v.price);
      var was = $('[data-cs-was]', pdp);
      if (was) { was.hidden = !(v.compare > v.price); was.textContent = money(v.compare); }
      btn.disabled = !v.available;
      btn.textContent = !v.available ? tr('sold_out', 'Sold out') : (v.pre ? tr('pre_order', 'Pre-order') : tr('add_to_bag', 'Add to bag')) + ' · ' + money(v.price);
      var k = $('[data-cs-klarna]', pdp);
      if (k) { var tpl = k.getAttribute('data-template'); var link = $('a', k); k.innerHTML = esc(tpl).replace('[amount]', money(Math.floor(v.price / 3))) + (link ? ' ' + link.outerHTML : ''); }
      var sub = $('[data-cs-sticky-sub]', pdp); if (sub) { sub.textContent = v.title.replace(/ \/ /g, ' · ') + ' · ' + money(v.price); }
      if (v.media_id) { goToMedia(v.media_id); }
      updateAddon();
      if (window.history.replaceState) { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString()); }
    }
    function addonVariant() {
      if (!upsellVariants.length) { return null; }
      var colours = current ? current.options : [];
      return upsellVariants.filter(function (u) { return u.available && u.options.some(function (o) { return colours.indexOf(o) > -1; }); })[0] || upsellVariants.filter(function (u) { return u.available; })[0];
    }
    function updateAddon() {
      var a = $('[data-cs-addon]', pdp); if (!a) { return; }
      var u = addonVariant();
      var isGift = T.gift && String(T.gift.giftId) === a.getAttribute('data-product-id');
      a.hidden = !u || isGift;
      if (isGift) { var c = $('[data-cs-addon-check]', a); if (c) { c.checked = false; } }
      var s = $('[data-cs-addon-sub]', a);
      if (u && s && !s._base) { s._base = s.textContent; }
      if (u && s) { s.textContent = s._base + (u.title && u.title !== 'Default Title' ? ' · ' + u.title.replace(/ \/ /g, ' · ') : ''); }
    }
    pdp.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cs-option] [data-value]');
      if (b) { var fs = b.closest('[data-cs-option]'); selected[Number(fs.getAttribute('data-cs-option'))] = b.getAttribute('data-value'); update(); }
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!current || !current.available) { return; }
      var items = [item(current)];
      var chk = $('[data-cs-addon-check]', pdp);
      if (chk && chk.checked) { var u = addonVariant(); if (u) { items.push(item(u)); } }
      btn.disabled = true;
      addItems(items).then(function () { if (chk) { chk.checked = false; } }).finally(function () { btn.disabled = !current.available; });
    });

    /* gallery */
    var track = $('[data-cs-track]', pdp), thumbs = $$('[data-cs-thumb]', pdp), counter = $('[data-cs-index]', pdp);
    function goTo(i) { if (!track) { return; } var s = track.children[i]; if (s) { track.scrollTo({ left: s.offsetLeft, behavior: 'smooth' }); } }
    function goToMedia(id) { var t = thumbs.filter(function (x) { return x.getAttribute('data-media-id') === String(id); })[0]; if (t) { goTo(Number(t.getAttribute('data-cs-thumb'))); } }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(Number(t.getAttribute('data-cs-thumb'))); }); });
    if (track) {
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (counter) { counter.textContent = i + 1; }
        thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      }, { passive: true });
    }

    /* sticky bar */
    var sticky = $('[data-cs-sticky]', pdp);
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        var show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', show); sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      }).observe(btn);
      $('[data-cs-sticky-add]', sticky).addEventListener('click', function () {
        if (form.requestSubmit) { form.requestSubmit(); } else { form.dispatchEvent(new Event('submit', { cancelable: true })); }
      });
    }

    /* size popup */
    var modal = $('[data-cs-size-modal]', pdp);
    $$('[data-cs-size-open]', pdp).forEach(function (o) { o.addEventListener('click', function () { if (modal && modal.showModal) { modal.showModal(); } }); });
    if (modal) {
      $('[data-cs-size-close]', modal).addEventListener('click', function () { modal.close(); });
      modal.addEventListener('click', function (e) { if (e.target === modal) { modal.close(); } });
    }
    update();
  });

  /* ---------- size tables: tabs + cm/in ---------- */
  $$('[data-cs-sizes]').forEach(function (box) {
    var tabs = $$('[data-cs-size-tab]', box), panels = $$('[data-cs-size-panel]', box);
    function show(id) {
      tabs.forEach(function (t) { var on = t.getAttribute('data-cs-size-tab') === id; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on); });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-cs-size-panel') !== id; });
    }
    var active = tabs.filter(function (t) { return t.classList.contains('is-active'); })[0] || tabs[0];
    if (active) { show(active.getAttribute('data-cs-size-tab')); }
    tabs.forEach(function (t) { t.addEventListener('click', function () { show(t.getAttribute('data-cs-size-tab')); }); });
    $$('[data-cs-unit]', box).forEach(function (u) {
      u.addEventListener('click', function () {
        var unit = u.getAttribute('data-cs-unit');
        $$('[data-cs-unit]', box).forEach(function (x) { x.classList.toggle('is-active', x === u); });
        $$('[data-cs-cm]', box).forEach(function (td) {
          var cm = td.getAttribute('data-cs-cm');
          td.textContent = unit === 'cm' ? cm : cm.replace(/\d+(?:[.,]\d+)?/g, function (n) { return (parseFloat(n.replace(',', '.')) / 2.54).toFixed(1).replace(/\.0$/, ''); });
        });
        $$('[data-cs-head]', box).forEach(function (th) { var h = th.getAttribute('data-cs-head'); th.textContent = unit === 'cm' ? h : h.replace(/\(cm\)/i, '(in)'); });
      });
    });
  });

  /* ---------- countdowns ---------- */
  $$('[data-cs-countdown]').forEach(function (el) {
    var end = new Date(el.getAttribute('data-cs-countdown').replace(/([+-]\d\d)(\d\d)$/, '$1:$2')).getTime();
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
      $('[data-d]', el).textContent = pad(Math.floor(s / 86400));
      $('[data-h]', el).textContent = pad(Math.floor(s % 86400 / 3600));
      $('[data-m]', el).textContent = pad(Math.floor(s % 3600 / 60));
      if (s === 0) { el.classList.add('is-done'); }
    }
    if (!isNaN(end)) { tick(); setInterval(tick, 30000); } else { el.hidden = true; }
  });

  /* ---------- videos ---------- */
  document.addEventListener('click', function (e) {
    var clip = e.target.closest('[data-cs-clip]');
    if (clip) {
      var v = $('video', clip); if (!v) { return; }
      if (v.paused) { v.muted = false; v.play(); clip.classList.add('is-playing'); } else { v.pause(); clip.classList.remove('is-playing'); }
      return;
    }
    var tog = e.target.closest('[data-cs-video-toggle]');
    if (tog) {
      var hv = $('video', tog.parentNode); if (!hv) { return; }
      if (hv.paused) { hv.play(); tog.setAttribute('aria-label', tr('pause_video', 'Pause video')); } else { hv.pause(); tog.setAttribute('aria-label', tr('play_video', 'Play video')); }
    }
  });
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    $$('[data-cs-hero-video] video').forEach(function (v) { v.removeAttribute('autoplay'); v.pause(); });
  }

  /* ---------- help search ---------- */
  $$('[data-cs-help]').forEach(function (help) {
    var input = $('[data-cs-help-search]', help), empty = $('[data-cs-help-empty]', help);
    if (!input) { return; }
    input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase(), shown = 0;
      $$('[data-cs-q]', help).forEach(function (d) {
        var hit = !q || d.textContent.toLowerCase().indexOf(q) > -1;
        d.hidden = !hit; if (hit) { shown++; if (q) { d.open = true; } }
      });
      $$('.cs-help__topic', help).forEach(function (h) { h.hidden = !!q; });
      if (empty) { empty.hidden = shown > 0; }
    });
  });


  /* ---------- welcome pop-up ---------- */
  $$('[data-cs-popup]').forEach(function (pop) {
    var KEY = 'cs_popup_' + (pop.getAttribute('data-section') || '');
    var days = Number(pop.getAttribute('data-days')) || 14;
    var box = $('.cs-popup__box', pop);
    function store(k, v) { try { if (v === undefined) { return window.localStorage.getItem(k); } window.localStorage.setItem(k, v); } catch (e) { return null; } }
    function open() {
      if (!pop.hidden) { return; }
      pop.hidden = false;
      requestAnimationFrame(function () { pop.classList.add('is-open'); });
      document.documentElement.classList.add('cs-lock');
      if (box) { box.focus(); }
    }
    function close(remember) {
      pop.classList.remove('is-open'); pop.hidden = true;
      document.documentElement.classList.remove('cs-lock');
      if (remember) { store(KEY, String(Date.now())); }
    }
    if (!window.csOpenPopup) { window.csOpenPopup = open; }
    pop.addEventListener('click', function (e) {
      if (e.target.closest('[data-cs-popup-close]')) { close(true); }
      var c = e.target.closest('[data-cs-copy]');
      if (c) {
        var code = ($('[data-cs-code]', pop) || {}).textContent || '';
        var done = function () { c.textContent = c.getAttribute('data-label-done') || tr('copied', 'Copied'); };
        if (navigator.clipboard) { navigator.clipboard.writeText(code.trim()).then(done, done); } else { done(); }
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) { close(true); } });
    var form = $('[data-cs-popup-form]', pop);
    if (form) { form.addEventListener('submit', function () { store(KEY + '_joined', '1'); }); }

    /* Shopify reloads the page after sign-up: show the thank-you with the code straight away */
    if ($('[data-cs-popup-success]', pop)) {
      /* Only the pop-up that was actually used shows its thank-you (other sign-up forms share Shopify's success flag) */
      if (store(KEY + '_joined') === '1') { open(); store(KEY + '_joined', 'done'); }
      return;
    }
    if ($('.cs-popup__error', pop)) { open(); return; }

    /* Theme editor: open while the section is selected */
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:select', function (e) { if (e.detail && e.detail.sectionId === pop.getAttribute('data-section')) { open(); } });
      document.addEventListener('shopify:section:deselect', function (e) { if (e.detail && e.detail.sectionId === pop.getAttribute('data-section')) { close(false); } });
      return;
    }
    if (store(KEY + '_joined')) { return; }
    var last = Number(store(KEY)) || 0;
    if (last && Date.now() - last < days * 86400000) { return; }
    var delay = Number(pop.getAttribute('data-delay'));
    setTimeout(open, (isNaN(delay) ? 8 : delay) * 1000);
    if (pop.getAttribute('data-exit') === 'true' && window.matchMedia('(pointer: fine)').matches) {
      document.addEventListener('mouseout', function onOut(e) {
        if (!e.relatedTarget && e.clientY <= 0) { document.removeEventListener('mouseout', onOut); open(); }
      });
    }
  });


  /* ---------- campaign buttons: put them at the start of the main menu ---------- */
  (function () {
    var targets = { bar: '.header__inline-menu > ul', drawer: '.menu-drawer__menu.has-submenu' };
    $$('template[data-cs-navpills]').forEach(function (tpl) {
      var where = tpl.getAttribute('data-cs-navpills');
      var list = $(targets[where]);
      if (!list || !tpl.content || !tpl.content.children.length) { return; }
      var frag = document.importNode(tpl.content, true);
      list.insertBefore(frag, list.firstChild);
    });
  })();

  /* ---------- auto-submit (sort, bag quantities) ---------- */
  /* ---------- top bar: rotate messages ---------- */
  $$('[data-cs-topbar]').forEach(function (bar) {
    var slides = $$('[data-cs-slide]', bar);
    if (slides.length < 2) { return; }
    var i = 0, timer = null, paused = false;
    var ms = (Number(bar.getAttribute('data-speed')) || 5) * 1000;
    function show(n) {
      slides[i].classList.remove('is-active'); slides[i].setAttribute('aria-hidden', 'true');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active'); slides[i].removeAttribute('aria-hidden');
    }
    function start() { stop(); timer = setInterval(function () { if (!paused && !document.hidden) { show(i + 1); } }, ms); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    bar.addEventListener('mouseenter', function () { paused = true; });
    bar.addEventListener('mouseleave', function () { paused = false; });
    bar.addEventListener('focusin', function () { paused = true; });
    bar.addEventListener('focusout', function () { paused = false; });
    bar.addEventListener('click', function (e) {
      if (e.target.closest('[data-cs-topbar-prev]')) { show(i - 1); start(); }
      if (e.target.closest('[data-cs-topbar-next]')) { show(i + 1); start(); }
    });
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:block:select', function (e) {
        var k = slides.indexOf(e.target.closest ? e.target.closest('[data-cs-slide]') : null);
        if (k > -1) { stop(); show(k); }
      });
    }
    start();
  });

  /* ---------- links that open the sign-up pop-up ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-cs-popup-open], a[href$="#join"]');
    if (!a) { return; }
    e.preventDefault();
    if (window.csOpenPopup) { window.csOpenPopup(); return; }
    var email = document.getElementById('cs-footer-email');
    if (email) { email.scrollIntoView({ behavior: 'smooth', block: 'center' }); email.focus({ preventScroll: true }); }
  });

  document.addEventListener('change', function (e) {
    var el = e.target.closest('[data-cs-autosubmit]');
    if (el && el.form) { el.form.submit(); }
  });
})();
